export default __webpack_public_path__ + "static/media/product-11.7328e509.jpg";